import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesInsights } from "../../constants";
import { PriceInsightsListItem } from "../../insights.types";

export const requestPriceInsights = async (
  params: GetListRequestParams
): Promise<GetListResponse<PriceInsightsListItem>> => {
  return await instance.get(ApiRoutesInsights.PriceInsights, {
    params
  });
};
